import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import { useParams } from 'react-router-dom';
import {
  Card, CardHeader, CardContent, Divider, Typography,
  List, ListItem, ListItemText, makeStyles, Button
} from '@material-ui/core';
import Layout from '../../components/layout/Layout';
import { gregorianToJalali, toFarsiDigits } from '../../assets/utils';

const useStyles = makeStyles(() => ({
  root: { background: '#f1f1f1', flexGrow: 1 },
  section: { marginTop: 16, marginBottom: 8 },
}));

export default function RequestDetail() {
  const classes = useStyles();
  const { contractId, requestId } = useParams();

  const [req, setReq] = useState(null);
  const [docs, setDocs] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancel = false;
    const run = async () => {
      try {
        setErr('');
        // 1) جزئیات صورت‌وضعیت
        const r1 = await api.get(`/contracts/${contractId}/requests/${requestId}/`);
        // 2) مدارک صورت‌وضعیت
        const r2 = await api.get(`/contracts/${contractId}/documents/request/${requestId}/`);

        if (!cancel) {
          setReq(r1.data);
          const d = Array.isArray(r2.data) ? r2.data : (r2.data.results || []);
          setDocs(d);
        }
      } catch (e) {
        if (!cancel) setErr('خطا در دریافت اطلاعات صورت‌وضعیت');
      }
    };
    run();
    return () => { cancel = true; };
  }, [contractId, requestId]);

  return (
    <Layout>
    <Card elevation={5} className={classes.root}>
      <CardHeader title={`صورت‌وضعیت ${toFarsiDigits(requestId)} قرارداد ${toFarsiDigits(contractId)}`} />
      <Divider />
      <CardContent>
        {err && <Typography color="error">{err}</Typography>}

        {req ? (
          <>
            <div className={classes.section}>
              <Typography variant="h6">جزئیات</Typography>
              <Typography>موضوع: {req.title || req.subject || '—'}</Typography>
              <Typography>تاریخ: {req.date ? toFarsiDigits(gregorianToJalali(req.date)) : '—'}</Typography>
              <Typography>وضعیت: {req.status_fa || req.status || '—'}</Typography>
              {/* هر فیلد دیگری داشتی همین‌جا اضافه کن */}
            </div>

            <Divider className={classes.section} />

            <div className={classes.section}>
              <Typography variant="h6">مدارک</Typography>
              {docs.length === 0 ? (
                <Typography>مدرکی ثبت نشده است.</Typography>
              ) : (
                <List dense>
                  {docs.map((d, i) => (
                    <ListItem key={d.id || i} divider>
                      <ListItemText
                        primary={d.title || d.filename || `مدرک ${toFarsiDigits(i + 1)}`}
                        secondary={(d.created_at && toFarsiDigits(gregorianToJalali(d.created_at))) || d.type || ''}
                      />
                      {d.file && (
                        <Button component="a" href={d.file} target="_blank" rel="noopener noreferrer" variant="outlined">
                          دانلود
                        </Button>
                      )}
                    </ListItem>
                  ))}
                </List>
              )}
            </div>
          </>
        ) : (
          <Typography>در حال بارگذاری…</Typography>
        )}
      </CardContent>
    </Card>
    </Layout>
  );
}